<template>
  <v-app-bar
    v-if="showHeader"
    v-sticky="stickyHeader"
    :sticky-z-index="6"
    clipped-left
    class="site-header elevation-1"
    :color="partnerHeaderColor"
    :height="localHeaderHeight"
    :style="{ '--height': localHeaderHeight + 'px' }"
  >
    <v-container
      class="content-width apricot-header-container"
      :fluid="$vuetify.breakpoint.lgAndDown"
    >
      <div class="apricot-cta-wrapper-mobile">
        <h6>
          <a
            href="tel:02890616718"
          >
            <v-icon
              class="mb-2px"
              color="#fff"
              light
              size="14"
            >
              mdi-phone
            </v-icon>
            028 9061 6718
          </a>
        </h6>
      </div>
      <header-logos class="apricot-logo" />
      <div class="apricot-cta-wrapper flex-grow-1 flex-shrink-0">
        <a
          class="apricot-telephone"
          href="tel:02890616718"
        >
          028 9061 6718
        </a>
        <a
          class="apricot-contact-us"
          href="https://www.apricotinsurance.co.uk/contact-page/"
        >
          Contact Us
        </a>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import SiteHeader from '@/components/SiteHeader/SiteHeader.vue';

export default {
  extends: SiteHeader,
};
</script>

<style lang="scss" scoped>
.site-header::v-deep {
  .v-toolbar__content {
    padding: 0;
  }

  .apricot-header-container.container {
    padding: 0 32px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

    @media screen and (max-width: 959px) {
      padding: 0 12px;
    }

    @media screen and (max-width: 767px) {
      padding: 0;
      display: block;
    }
  }
}

.apricot-logo {
  max-height: 55px;
  margin-top: 5px;

  &::v-deep {
    .container {
      padding: 0 5px;
    }
  }
}

.apricot-cta-wrapper {
  display: none;

  a {
    padding: 13px 30px;
    margin-left: 35px;
    font-weight: 500;
    text-transform: uppercase;
    border: 2px solid var(--v-primary-base, $clr-primary);
    font-size: 16px;
    font-family: 'Poppins', Helvetica, Arial, Lucida, sans-serif !important;
    border-radius: 5px;
  }

  @media screen and (min-width: 768px) {
    display: block;
  }
}

.apricot-cta-wrapper-mobile {
  padding: 11px calc(0.25 * var(--height));
  background-color: var(--v-primary-base, $clr-primary);
  text-align: right;

  a {
    color: $clr-white;
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
}

.apricot-telephone {
  color: var(--v-primary-base, $clr-primary);
  background-color: $clr-white;
}

.apricot-contact-us {
  color: $clr-white;
  background-color: var(--v-primary-base, $clr-primary);
  box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.25);
}
</style>
